import { produce } from "immer";

import type {
    InsightDetailOption,
    InsightDetailProps,
} from "../utils/insightDetail.utils";
import { InsightDetailType } from "../utils/insightDetail.utils";

import { zustandStore } from "./zustand.helpers";

export interface InsightDetailComponentState {
    identifier: string;
    familyName: string;
    open: boolean;
    onMount?: (props: InsightDetailProps) => void;
    onClose?: () => void;
    headerOption: InsightDetailOption;
    bodyOption: InsightDetailOption;
    footerOption: InsightDetailOption;
}

export const defaultInsightDetailOption: InsightDetailOption = {
    type: InsightDetailType.VIEW,
    component: () => {
        return <></>;
    },
};

export const initialState: InsightDetailComponentState = {
    identifier: "",
    familyName: "",
    open: false,
    onMount: undefined,
    onClose: undefined,
    headerOption: defaultInsightDetailOption,
    bodyOption: defaultInsightDetailOption,
    footerOption: defaultInsightDetailOption,
};

export interface InsightDetailsActions {
    setOpen: (open: boolean) => void;
    setIdentifier: (identifier: string) => void;
    setFamilyName: (identifier: string) => void;
    setOnMount: (onMount: (props: InsightDetailProps) => void) => void;
    setOnClose: (onClose: () => void) => void;
    setHeaderOption: (headerOption: InsightDetailOption) => void;
    setBodyOption: (bodyOption: InsightDetailOption) => void;
    setFooterOption: (footerOption: InsightDetailOption) => void;
    reset: () => void;
}

export const { store: insightDetailComponentStore } = zustandStore<
    InsightDetailComponentState,
    InsightDetailsActions
>("InsightDetailComponents", initialState, (set: any, get: any) => ({
    setOpen: (open: boolean) =>
        set(() => {
            const state: InsightDetailComponentState = get();
            return produce(state, (draft) => {
                draft.open = open;
                return draft;
            });
        }),
    setIdentifier: (identifier: string) =>
        set(() => {
            const state: InsightDetailComponentState = get();
            return produce(state, (draft) => {
                draft.identifier = identifier;
                return draft;
            });
        }),
    setFamilyName: (familyName: string) =>
        set(() => {
            const state: InsightDetailComponentState = get();
            return produce(state, (draft) => {
                draft.familyName = familyName;
                return draft;
            });
        }),
    setOnMount: (onMount: (props: InsightDetailProps) => void) =>
        set(() => {
            const state: InsightDetailComponentState = get();
            return produce(state, (draft) => {
                draft.onMount = onMount;
                return draft;
            });
        }),
    setOnClose: (onClose: () => void) =>
        set(() => {
            const state: InsightDetailComponentState = get();
            return produce(state, (draft) => {
                draft.onClose = onClose;
                return draft;
            });
        }),
    setHeaderOption: (headerOption: InsightDetailOption) =>
        set(() => {
            const state: InsightDetailComponentState = get();
            return produce(state, (draft) => {
                draft.headerOption = headerOption;
                return draft;
            });
        }),
    setBodyOption: (bodyOption: InsightDetailOption) =>
        set(() => {
            const state: InsightDetailComponentState = get();
            return produce(state, (draft) => {
                draft.bodyOption = bodyOption;
                return draft;
            });
        }),
    setFooterOption: (footerOption: InsightDetailOption) =>
        set(() => {
            const state: InsightDetailComponentState = get();
            return produce(state, (draft) => {
                draft.footerOption = footerOption;
                return draft;
            });
        }),
    reset: () => set(() => ({ ...initialState })),
}));
